import { render, staticRenderFns } from "./message.vue?vue&type=template&id=68047d06&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&id=68047d06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68047d06",
  null
  
)

export default component.exports